var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"StatusIndicator",class:_vm.indicatorClasses},[_c('span',{staticClass:"StatusIndicator__beacon"})])}
var staticRenderFns = []

export { render, staticRenderFns }